import UploadFileForm2 from "../../components/files/UploadFileForm";

const UploadPricesPage = () => {
    return (
        <UploadFileForm2/>
    )
}

export default UploadPricesPage;